import { type Media, type Project, type PropertyUnit, type Tenant } from '@/payload-types';

export type Point = { x: number; y: number };
export type Shape = Point[];

export enum MapColors {
  hover = '#ffffff',
  available = '#00c951',
  sold = '#fb2c36',
}

export type Brand = {
  logo?: string | null;
  name: string;
  tenantName: string;
  homeUrl: string;
};

export type PatchedProject = Omit<Project, 'logo' | 'projectPictures' | 'mapImage'> & {
  logo?: Media;
  mapConfig: {
    mapImage: Media;
    hoverColor: string;
    availableColor: string;
    soldColor: string;
    zoomIntoProperty: boolean;
    showColorsAlways: boolean;
  };
  projectPictures: { image: Media; id: string }[];
};

export type PatchedTenant = Omit<Tenant, 'logo'> & {
  logo?: Media;
};

export type PatchedPropertyUnit = Omit<
  PropertyUnit,
  'propertyUnitPictures' | 'documents' | 'demarcationShape' | 'project' | 'slug'
> & {
  slug: string;
  project: PatchedProject;
  documents: { document: Media; id: string; name: string }[];
  propertyUnitPictures: { image: Media; id: string }[];
  demarcationShape: { x: number; y: number; caption: string }[];
};
